//ReadTVBook.js
import React, { useCallback, useState, useEffect, useHistory } from "react";
import { useSelector } from "react-redux";
import useFetch from "../../hooks/useFetch";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useSwipeable } from "react-swipeable";
import Tooltip from '../../components/utils/Tooltip';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlay,
  faPlayCircle,
  faStop,
  faVolumeMute,
  faVolumeUp,
  faSpinner,
  faMusic,
  faCommenting,
  faEdit,
  faLink,
} from "@fortawesome/free-solid-svg-icons";
import Speech from "speak-tts";
import "./ReadTVBook.css";

// ✅ Correct path matching your public folder structure
const backgroundMusic = process.env.PUBLIC_URL + '/assets/sounds/AnimalMovieRingtone.mp3';

const ReadTVBook = () => {
  const authState = useSelector((state) => state.authReducer);
  const [fetchData, { loading }] = useFetch();
  const navigate = useNavigate();
  const location = useLocation();
  const [userId, setUserId] = useState(authState.user._id);
  const [isImportantChecked, setIsImportantChecked] = useState(false);
// Retrieve state from location or fallback to localStorage
  // Function to get state from localStorage
  const getStateFromLocalStorage = (key) => {
    try {
      const storedState = localStorage.getItem(key);
      return storedState ? JSON.parse(storedState) : null;
    } catch (error) {
      console.error(`Error parsing state from localStorage`, error);
      return null;
    }
  };
  
const state = location.state ?? getStateFromLocalStorage("savedState") ?? {};

const bookMasterId = state?.bookMasterId ?? "defaultBookMasterId";
const bookCollectionName = state?.bookCollectionName ?? "defaultCollectionName";
const pageNumber = state?.lastPageRead ?? 1; 
const bookPages = state?.bookPages ?? [];
const isChildren = state?.isChildren ?? 0;

const [pageContent, setPageContent] = useState("");
const [splText, setSplText] = useState("");

const [hasAddlSplText, setHasAddlSplText] = useState(false);
const [addlSplText, setAddlSplText] = useState([]);
const [addlSplTextClicked, setAddlSplTextClicked] = useState(false);
const [selectedLangCode, setSelectedLangCode] = useState('zh-CN');
const [selectedAddlText, setSelectedAddlText] = useState('');
const [bookTitle, setBookTitle] = useState("");

const [currentPageNumber, setCurrentPageNumber] = useState(pageNumber);
const [hasSpeech, setHasSpeech] = useState(0);
const [hasMusic, setHasMusic] = useState(0);
const [hasVideo, setHasVideo] = useState(0);
const [videoUrl, setVideoUrl] = useState(0);
const [isBase64Audio, setIsBase64Audio] = useState(0);
const [base64Audio, setBase64Audio] = useState(false);
const [readFromSplText, setReadFromSplText] = useState(0);
const [musicAudio] = useState(new Audio(backgroundMusic));
const [pageCount, setPageCount] = useState(bookPages);
const [isSpeaking, setIsSpeaking] = useState(false);
const [isListening, setIsListening] = useState(false);
const [isFlipped, setIsFlipped] = useState(false);
const [dateRead, setDateRead] = useState(new Date());
const [pageLoadTime, setPageLoadTime] = useState(null);
const [readTimeInMiliseconds, setReadTimeInMiliseconds] = useState(0);
const [readingRemarks, setReadingRemarks] = useState("");
const [isLogSaved, setIsLogSaved] = useState(true);
const [isInteracted, setIsInteracted] = useState(false);
const [successMessage, setSuccessMessage] = useState(false);
const [userCommentTitle, setUserCommentTitle] = useState("");
const [userCommentDetails, setUserCommentDetails] = useState("");

const [listLink, setListLink] = useState(false);
const [addNewLink, setAddNewLink] = useState(false);
const [closeLink, setCloseLink] = useState(false);

const [linkName, setLinkName] = useState("");
const [linkPageName, setLinkPageName] = useState("");
const [linkTitle, setLinkTitle] = useState("");
const [linkAddress, setLinkAddress] = useState("");

const [isVideoChecked, setIsVideoChecked] = useState(false);
const [linkDetails, setLinkDetails] = useState("");
const [bookLinkSaved, setBookLinkSaved] = useState(false);
const [bookLinkSavedMsg, setBookLinkSavedMsg] = useState(false);
const [savedBookLinkMsg, setSavedBookLinkMsg] = useState('');
const [bookLinkClicked, setBookLinkClicked] = useState(false);
const [bookLinkCloseClicked, setBookLinkCloseClicked] = useState(false);
const [bookLinkToBeDisabled, setBookLinkToBeDisabled] = useState(false);
const [saveBookLinkToBeDisabled, setSaveBookLinkToBeDisabled] = useState(false);
const [saveBookLinkClicked, setSaveBookLinkClicked] = useState(false);

const [elapsedTime, setElapsedTime] = useState(0);
const [error, setError] = useState(false);
const [commentListFetched, setCommentListFetched] = useState(false)
const [commentData, setCommentData] = useState([]);
const [postCommentClicked, setPostCommentClicked] = useState(false);
const [postedComment, setPostedComment] = useState('');
const [errors, setErrors] = useState();
const [userComment, setUserComment] = useState('');
const [postedCommentMsg, setPostedCommentMsg] = useState('');
const [isVisibleToAllChecked, setIsVisibleToAllChecked] = useState(false);
const [postToBeDisabled, setPostToBeDisabled]=useState(false);
const [readCommentClicked,setReadCommentClicked]=useState(false);
const [postCloseClicked, setPostCloseClicked] = useState(false);
const [readCommentCloseClicked, setReadCommentCloseClicked] = useState(false);

  useEffect(() => {
    const startTime = new Date();
    setPageLoadTime(startTime);
    // console.log(`Page load start time: ${startTime}`);
  }, []); // Empty dependency array ensures this runs only once when the component mounts


  // Function to save state to localStorage
  const saveStateToLocalStorage = (key, state) => {
    try {
      const jsonState = JSON.stringify(state);
      localStorage.setItem(key, jsonState);
    } catch (error) {
      console.error(`Error saving state to localStorage`, error);
    }
  };

  // Retrieve state on component mount
  useEffect(() => {
    const savedState = getStateFromLocalStorage("savedState");
    if (!location.state && savedState) {
      navigate(location.pathname, { state: savedState, replace: true });
    } else if (
      location.state &&
      JSON.stringify(location.state) !== JSON.stringify(savedState)
    ) {
      saveStateToLocalStorage("savedState", location.state);
    }
  }, [location.state, navigate, location.pathname]);

  useEffect(() => {
    setPageLoadTime(new Date());
    // console.log("Page load time on page mount: ",pageLoadTime);
  }, []);

  const resetElapsedTime = () => {
    setElapsedTime(0);
  };
  useEffect(() => {
    const timer = setInterval(() => {
      setElapsedTime((prevTime) => prevTime + 1);
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  // BookPage
  const fetchBookPage = useCallback(() => {
    const config = {
      url: "/readbook",
      method: "post",
      headers: { Authorization: authState.token },
      data: {
        bookMasterId,
        bookCollectionName,
        currentPageNumber,
        readerCode: authState.user.think5whyscode,
        readerName: authState.user.name
      },
    };

    fetchData(config, { showSuccessToast: false })
      .then((response) => {
        if (response && response.pageContent) {
          // console.log("Page Content ",response);
          setPageContent(response.pageContent);
          setSplText(response.splText);
          setBookTitle(response.bookTitle);
          setHasSpeech(response.hasSpeech);
          setHasMusic(response.hasMusic);
          setHasVideo(response.hasVideo);
          setVideoUrl(response.videoURL);
          setIsBase64Audio(response.isBase64Audio);
          setBase64Audio(response.base64Audio);
          setHasAddlSplText(response.hasAddlSplText);
          setAddlSplText(response.addlSplText);
          setError(null);
        } else {
          console.error(
            "Invalid response format: Set master list not found in response"
          );
        }
        resetElapsedTime();
        setPageLoadTime(new Date());
      })
      .catch((error) => {
        console.error("Error fetching book page:", error);
        console.error("Error fetching set masters:", error);
      });
  }, [
    authState.token,
    bookMasterId,
    bookCollectionName,
    currentPageNumber,
    fetchData,
  ]);

  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchBookPage();
  }, [
    authState.isLoggedIn,
    fetchBookPage,
    location.state.bookMasterId,
    location.state.bookCollectionName,
    location.state.lastPageRead,
  ]);

  // Save Read Log
  const saveReadLog = async (remarks, elapsedTime, whichButton) => {
    const localDateString = new Date(dateRead - dateRead.getTimezoneOffset() * 60000).toISOString();
    try {
      // console.log(
      //   "Reading Remarks: ",
      //   whichButton,
      //   " Remarks: ",
      //   remarks,
      //   " splText ",
      //   splText,
      //   dateRead
      // );
      const readingRemarks = isChildren === 1 ? splText : remarks;
      // console.log("readingRemarks",readingRemarks);
      // console.log("splText",splText);
      // console.log("remarks",remarks);
      // console.log("isChildren",isChildren);
      const response = await fetch("/api/myreadinglog", {
        method: "POST",
        headers: {
          Authorization: authState.token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          bookId: bookMasterId,
          userId: userId,
          dateRead: localDateString,
          pageNumber: currentPageNumber,
          readTimeInMiliseconds: elapsedTime,
          readingRemarks: readingRemarks,
          readingMode: "TV",
          isActive: 1,
          isDeleted: 0,
          coReaderId: userId,
          readerCode: authState.user.think5whyscode,
          readerName: authState.user.name,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to update app like");
      }

      const data = await response.json();
      setSuccessMessage(true);
      setReadTimeInMiliseconds(0);
      setPageLoadTime(new Date());
    } catch (error) {
      console.error("Error while saving read log:", error);
    }
  };

  const saveReadLogIfNeeded = () => {
    if (isInteracted && !isLogSaved) {
      setCurrentPageNumber(currentPageNumber);
      let currentTime = new Date();
      const elapsedTime = currentTime - pageLoadTime;
      setReadTimeInMiliseconds(elapsedTime);
      setReadingRemarks("Swipe");
      saveReadLog(currentPageNumber, elapsedTime, "Selected Page");
      currentTime = new Date();
      setPageLoadTime(currentTime);
      setIsLogSaved(true);
    }
  };

  useEffect(() => {
    setReadTimeInMiliseconds();
    setReadingRemarks();
    setPageLoadTime(new Date());
  }, []);

  useEffect(() => {
    //
  }, [readTimeInMiliseconds]);

  const handlePageChange = (e) => {
    const selectedPage = parseInt(e.target.value);
    setCurrentPageNumber(selectedPage);
    const currentPageNumber = selectedPage;
    setReadingRemarks("Select Page Clicked");
    let currentTime = new Date();
    const elapsedTime = currentTime - pageLoadTime;
    setReadTimeInMiliseconds(elapsedTime);

    saveReadLog(currentPageNumber, elapsedTime, "Selected Page");
    currentTime = new Date();
    setPageLoadTime(currentTime);
    // setSelectedLangCode('hi-IN');
    setSelectedAddlText('');
  };

  useEffect(() => {
    setReadTimeInMiliseconds();
    setReadingRemarks();
    setPageLoadTime(new Date());
  }, []);

  useEffect(() => {
    //
  }, [readTimeInMiliseconds]);

  const handleNextPage = () => {
    setReadingRemarks("Next button clicked");
    let currentTime = new Date();
    const elapsedTime = currentTime - pageLoadTime;
    setReadTimeInMiliseconds(elapsedTime);

    saveReadLog(currentPageNumber, elapsedTime, "Next Button");
    currentTime = new Date();
    setPageLoadTime(currentTime);

    if (currentPageNumber < pageCount) {
      speech.cancel();
      setIsSpeaking(false);
      setCurrentPageNumber(currentPageNumber + 1);
    }
    // setSelectedLangCode('hi-IN');
    setSelectedAddlText('');
  };

  useEffect(() => {
    setReadTimeInMiliseconds();
    setReadingRemarks();
    setPageLoadTime(new Date());
  }, []);

  useEffect(() => {
    //
  }, [readTimeInMiliseconds]);

  const handlePrevPage = () => {
    setReadingRemarks("Prev button clicked");
    let currentTime = new Date();
    const elapsedTime = currentTime - pageLoadTime;
    setReadTimeInMiliseconds(elapsedTime);
    saveReadLog(currentPageNumber, elapsedTime, "Prev Button");
    currentTime = new Date();
    setPageLoadTime(currentTime);
    if (currentPageNumber > 1) {
      speech.cancel();
      setIsSpeaking(false);
      setCurrentPageNumber(currentPageNumber - 1);
    }
    // setSelectedLangCode('hi-IN');
    setSelectedAddlText('');
  };

  useEffect(() => {
    setReadTimeInMiliseconds();
    setReadingRemarks();
    setPageLoadTime(new Date());
  }, []);

  useEffect(() => {
    //
  }, [readTimeInMiliseconds]);

  const handleClose = () => {
    setReadingRemarks("Close button clicked");
    const currentTime = new Date();
    const elapsedTime = currentTime - pageLoadTime;
    setReadTimeInMiliseconds(elapsedTime);
    const remarks = "Closed";
    saveReadLog(currentPageNumber, elapsedTime, "Close Button")
      .then(() => {
        window.location.href = "/tvbook-home";
      })
      .catch((error) => {
        console.error("Error saving log:", error);
      });
  };

  useEffect(() => {
    setReadTimeInMiliseconds(0);
    setPageLoadTime(new Date());
  }, []);

  useEffect(() => {
    //
  }, [readTimeInMiliseconds]);

  const speech = new Speech();
  const toggleSpeech = (myText, lang) => {
    // console.log(myText, lang);
    setSelectedLangCode(lang);
    setSelectedAddlText(myText);
    if (isSpeaking) {
      speech.cancel();
      setIsSpeaking(false);
    } else {
      setIsSpeaking(true);
      speech.setRate(1.0);
      speech.setPitch(2.0);
      speech.setVolume(1.0);
      speech.setLanguage(lang);
      speech.speak({ text: myText });
    }
  };

  useEffect(() => {
    return () => {
      if (isSpeaking) {
        speech.cancel();
        setIsSpeaking(false);
      }
    };
  }, [isSpeaking]);

  const toggleMusic = () => {
    if (isListening) {
      musicAudio.pause();
    } else {
      musicAudio.play();
    }

    setIsListening(!isListening);
  };

  musicAudio.addEventListener("ended", () => {
    if (isListening) {
      musicAudio.currentTime = 0;
      musicAudio.play();
    }
  });

  const watchVideo = () => {
    // console.log("Video URL Check ",hasVideo, videoUrl);
    if (videoUrl) {
      window.open(videoUrl, "_blank");
    }
  };

  const accessSite = (siteUrl) => {
    if (siteUrl) {
      const formattedUrl = siteUrl.startsWith("http://") || siteUrl.startsWith("https://")
        ? siteUrl
        : `http://${siteUrl}`;
      window.open(formattedUrl, "_blank");
    } else {
      console.error("URL is not provided.");
    }
  };
  
  const listenVoice = () => {
    if (base64Audio) {
      const audio = new Audio(`data:audio/mpeg;base64,${base64Audio}`);
      audio.play();
    }
  };

  const handleReadCommentClose = () => {
    setReadCommentClicked(false);
    setReadCommentCloseClicked(true);
  };

  const handleListLinkButtonClick = () => {
    setListLink(!listLink);
    setAddNewLink(false);
    fetchListLinkByPageNumber();
  };

  const handleCloseLinkButtonClick = () => {
    setBookLinkClicked(false);
  };

  const handleListLinkCloseButtonClick = () => {
    setListLink(false);
  };
  
  const bookLinks = () => {
    setErrors('');
    setSavedBookLinkMsg('');    
    setBookLinkClicked(true);
    setBookLinkCloseClicked(false);
    setBookLinkToBeDisabled(false);
    setSaveBookLinkClicked(false);
    setSaveBookLinkToBeDisabled(false);
  };

  const [listLinkData, setListLinkData] = useState([]);

  const fetchListLinkByPageNumber = useCallback(() => {
    const config = {
      url: "/myreadingnotesurls/linksbybookpage",
      method: "post",
      headers: { Authorization: authState.token },
      data: {
        bookId: bookMasterId, 
        userId: userId, 
        pageNumber: currentPageNumber
      }
    };
    // console.log("List Link config to server: ", config);
    
    fetchData(config, { showSuccessToast: false })
      .then(response => {
        // console.log("List Link Response:", response);
        if (response && response.status) {
          setListLinkData(response.urls);
          // console.log("setListLinkData ", response.urls); 
        } else {
          console.error("List Link data not found in response");
        }
      })
      .catch(error => {
        console.error("Error fetching List Link data:", error);
      });
  }, [authState.token, fetchData, bookMasterId, userId, currentPageNumber]);


  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchListLinkByPageNumber();
  }, [authState.isLoggedIn, fetchListLinkByPageNumber]);

  const sortedListLinkData = [...listLinkData ].sort((a, b) => b.linkName - a.linkName);

  const formatDateTime = (date) => {
    const options = {
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hour12: false
    };
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    const hours = jsDate.getHours().toString().padStart(2, '0');
    const minutes = jsDate.getMinutes().toString().padStart(2, '0');
    const seconds = jsDate.getSeconds().toString().padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };

  const readComment = () => {
    setReadCommentClicked(true);
    fetchReadCommentByPageNumber();
    setReadCommentCloseClicked(false);
  };

  //Read Comments List
  const fetchReadCommentByPageNumber = useCallback(() => {
    const config = {
      url: "/myreadingnotes/notesbybookpage",
      method: "post",
      headers: { Authorization: authState.token },
      data: {
        bookId: bookMasterId, 
        userId: userId, 
        pageNumber: currentPageNumber
      }
    };
    // console.log("Read Comments config to server: ", config);
    
    fetchData(config, { showSuccessToast: false })
      .then(response => {
        // console.log("Read Comments Response:", response);
        if (response && response.status) {
          setCommentData(response.notes);
          // console.log("setCommentData ", response.notes); // Log response.notes
        } else {
          console.error("Read Comments data not found in response");
        }
      })
      .catch(error => {
        console.error("Error fetching Read Comments data:", error);
      });
  }, [authState.token, fetchData, bookMasterId, userId, currentPageNumber]);


  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchReadCommentByPageNumber();
  }, [authState.isLoggedIn, fetchReadCommentByPageNumber]);

  const sortedCommentData = [...commentData ].sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated));

  const [showAllLangClicked, setShowAllLangClicked] = useState(false);
  const handleAllLangClicked = () => {
    setShowAllLangClicked(prevState => !prevState);
  };

  const handleAddlSplTextClicked = () => {
    setAddlSplTextClicked(prevState => !prevState);
  };

  const handleAddlSplTextLangChange = (event) => {
    const selectedLangCode = event.target.value; // Get selected value from the dropdown
    const selectedOption = addlSplText.find(item => item.langCode === selectedLangCode);
  
    // console.log(selectedLangCode, selectedOption?.addlText, selectedOption?.langCode);
  
    if (selectedOption) {
      setSelectedLangCode(selectedOption.langCode);
      setSelectedAddlText(selectedOption.addlText);
    } else {
      setSelectedLangCode(selectedLangCode);
      setSelectedAddlText('');
    }
  };

  // useEffect(() => {
  //   if (!authState.isLoggedIn) return;
  // }, [authState.isLoggedIn, setSelectedLangCode, setSelectedAddlText]);


  return (
    <div
      className="my-1 mx-auto py-2 bg-white text-black fixed-height-container"
      style={{ height: "100vh", overflow: "auto" }}
    >
      {loading ? (
        <div className="spinner-container">
          <div className="spinner">
            <FontAwesomeIcon icon={faSpinner} spin />
          </div>
        </div>
      ) : (
        <>
          <div
            className="fixed-height-container mt-2 mb-2"
            style={{
              flex: 1,
              overflowY: "auto",
              maxWidth: "100%",
              maxHeight: "100vh",
            }}
          >
            <div className="flex justify-between items-center mb-4 bg-cyan-900 text-white mr-1 ml-1">
              <div className="text-wrap flex justify-center">
                <h1 className="mt-1 mx-2 bg-cyan-900 text-white">
                  { hasAddlSplText && (<i className="fa fa-star text-white text-3xl" aria-hidden="true"></i>)}
                  <i className="fa fa-book-open text-white text-3xl" aria-hidden="true"></i>
                  <span className="text-yellow-300 ml-2 text-wrap text-3xl">{bookTitle}</span>
                </h1>
              </div>
              <div>
                <button className="mx-2 bg-cyan-900" onClick={handleClose}>
                  <i className="fa fa-times text-3xl" aria-hidden="true"></i>
                </button>
              </div>
            </div>
            { showAllLangClicked ? (
              <>
              <div
                className="page-content ml-2 mr-2 w-8/12"
                style={{ minHeight: "100%" }}
                dangerouslySetInnerHTML={{ __html: pageContent }}
              />
              { selectedAddlText !== '' && (
                <p className="w-8/12 text-4xl flex justify-center text-yellow-500">{selectedAddlText}</p>
              )}
              </>
            ): (
              <>
              <div
                className="page-content ml-2 mr-2"
                style={{ minHeight: "100%" }}
                dangerouslySetInnerHTML={{ __html: pageContent }}
              />
              { selectedAddlText !== '' && (
                  <p className="text-4xl flex justify-center text-yellow-500">{selectedAddlText}</p>
                )}
              </>
            )}
              </div>
            
            <div className="ml-1 mr-1 h-15 flex justify-between bg-black">
              <h3 className="book-timer ml-2 mr-2 text-2xl w-12">{elapsedTime} seconds</h3>
              <button
                className="ml-1 mt-2 max-w-10 bg-orange-600 text-white"
                onClick={() => {
                  toggleSpeech(splText, selectedLangCode);
                }}
                disabled={hasSpeech === 0}
              >
                {isSpeaking ? (
                  <FontAwesomeIcon icon={faStop} />
                ) : (
                  <FontAwesomeIcon icon={faPlay} />
                )}
              </button>
              {hasMusic && (
                <button
                  className="ml-1 mt-2 max-w-10 bg-green-800 text-white"
                  onClick={toggleMusic}
                  disabled={hasMusic === 0}
                >
                  {isListening ? (
                    <FontAwesomeIcon icon={faMusic} />
                  ) : (
                    <FontAwesomeIcon icon={faMusic} />
                  )}
                </button>
              )}
              { base64Audio && (
                <button
                  className="ml-1 mt-2 max-w-10 bg-blue-800 text-white"
                  onClick={listenVoice}
                  disabled={!base64Audio}
                >
                  <FontAwesomeIcon icon={faVolumeUp} />
                </button>
              )}
              <button
                className="ml-2 mt-2 max-w-10"
                onClick={watchVideo}
                disabled={hasVideo === 0}
              >
                <FontAwesomeIcon icon={faPlayCircle} />
              </button>

              <button
                className="ml-2 mt-2 max-w-10"
                onClick={handleAllLangClicked}
                disabled={hasAddlSplText === false}
              >
                {addlSplText.length > 0 && (
                  <i className="fa fa-globe text-white text-2xl max-w-10" aria-hidden="true"></i>
                )}
              </button>

              {showAllLangClicked && (
                <div className="fixed top-0 right-0 h-full w-1/3 bg-gray-800 z-50 overflow-y-auto">
                  <div className="bg-gray-800 p-6 rounded-l-lg shadow-lg relative h-full flex flex-col">  
                    <div className="flex justify-end items-end">
                    
                      <button
                        className="text-white p-2 bg-blue-500 w-8 rounded flex items-center justify-center"
                        onClick={handleAllLangClicked}
                      >
                        <i className="fa fa-times mr-2" aria-hidden="true"></i> 
                        {/* {selectedLangCode} */}
                      </button>    
                    </div>
                    
                    <div className="mb-4 flex flex-col space-y-1">
                      {addlSplText.map((item) => (
                        <div key={item.langCode} className="flex flex-col">
                          <div className="flex justify-end items-end  -mt-5">
                            <p className="text-xs text-white text-right">{item.langName}</p>
                          </div>
                          <div className="flex justify-end items-end">
                            <button
                              className="text-white p-2 bg-blue-500 rounded w-8 flex items-center justify-center mr-2"
                              onClick={() => {
                                setSelectedLangCode(item.langCode);
                                toggleSpeech(item.addlText, item.langCode);  
                              }}
                            >
                              <i className="fa fa-play text-lg" aria-hidden="true"></i>
                            </button>
                            <button className={`w-full rounded ml-2 ${selectedLangCode === item.langCode ? 'bg-blue-700' : 'bg-gray-700'} text-white`}>
                               {item.addlText}
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              <button
                className="ml-2 mt-2 max-w-10"
                onClick={handleAddlSplTextClicked}
                disabled ={true}
                // disabled={!hasAddlSplText}
              >
                {addlSplText.length > 0 && (
                  <i className="fa fa-star text-white text-2xl max-w-10" aria-hidden="true"></i>
                )}
              </button>

              {addlSplTextClicked && (
                <div className="fixed inset-0 bg-gray-800 bg-opacity-60 flex justify-center items-center z-50">
                  <div className="bg-gray-900 p-6 rounded shadow-lg relative">
                    <div className="mb-4">
                      <label htmlFor="languageSelect" className="block text-white mb-2">Select Language:</label>
                      <select
                        id="languageSelect"
                        onChange={handleAddlSplTextLangChange}
                        value={selectedLangCode}
                        className="p-2 border border-gray-500 rounded bg-gray-700 text-white"
                      >
                        <option value="">Select a language</option>
                        {addlSplText.map((item) => (
                          <option key={item.langCode} value={item.langCode}>
                            {item.langName}
                          </option>
                        ))}
                      </select>
                    </div>
                    
                    {selectedLangCode && (
                      <button
                        className="w-full bg-green-500 text-white py-2 rounded mb-4 flex justify-center items-center"
                        onClick={() => {
                          const selectedItem = addlSplText.find(item => item.langCode === selectedLangCode);
                          if (selectedItem) {
                            setSelectedLangCode(selectedLangCode);
                            setSelectedAddlText(selectedItem.addlText);
                            handleAddlSplTextClicked(); // To hide the overlay
                          }
                        }}
                      >
                        {addlSplText.find(item => item.langCode === selectedLangCode)?.langName || "Select Language"}
                      </button>
                    )}
                    
                    <button
                      className="w-full bg-blue-500 text-white py-2 rounded flex justify-center items-center"
                      onClick={handleAddlSplTextClicked}
                    >
                      <i className="fa fa-child text-2xl mr-2" aria-hidden="true"></i>
                      <span>Cancel</span>
                    </button>
                  </div>
                </div>
              )}

              <button
                className="ml-2 mt-2 max-w-10 bg-purple-800 text-white"
                onClick={bookLinks}
              >
                <FontAwesomeIcon icon={faLink} />
              </button>
              <button
                title="Prev"
                className="ml-2 mt-2 max-w-10 bg-cyan-800 text-white"
                onClick={handlePrevPage}
                disabled={currentPageNumber === 1}
              >
                <i className="fa fa-angle-left text-2xl" aria-hidden="true"></i>
              </button>
              <select
                className="ml-2 mt-3 max-w-12 text-2xl bg-cyan-800 text-white border-2 border-cyan-900"
                value={currentPageNumber}
                onChange={handlePageChange} 
              >
                {[...Array(pageCount).keys()].map((page) => (
                  <option
                    className="text-white text-2xl"
                    key={page + 1}
                    value={page + 1}
                  >
                    {page + 1}
                  </option>
                ))}
              </select>
              <button
                title="Next"
                className="ml-2 mt-2 max-w-10 bg-cyan-800 text-white"
                onClick={handleNextPage}
                disabled={currentPageNumber === pageCount}
              >
                <i className="fa fa-angle-right text-2xl" aria-hidden="true"></i>
              </button>
              <button className="ml-2 mr-4 mt-2 max-w-10 bg-cyan-800 text-white" onClick={handleClose}>
                <i className="fa fa-times text-2xl" aria-hidden="true"></i>
              </button>
            </div>
            {bookLinkClicked && (
              <>
              <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center" style={{ zIndex: 1000 }}>
                <div className="w-10/12 max-h-[80vh] overflow-y-auto flex flex-col justify-between bg-blue-200 text-black border-b border-b-gray-300 mr-4 ml-4 p-4">
                  <div className="flex justify-center">
                    <p className="text-yellow-800 text-lg">External Links/URLs of the Books {bookTitle}, Page Number {currentPageNumber}</p>
                  </div>
                  <div className="flex justify-center mt-4">
                      <button
                        className="bg-green-700"
                        onClick={handleListLinkButtonClick}
                        style={{ width: "150px" }}
                      >
                        List
                      </button>
                      <button
                        className="bg-green-700 ml-2"
                        onClick={handleCloseLinkButtonClick}
                        style={{ width: "150px" }}
                      >
                        Close
                      </button>
                  </div>
                  {listLink && (
                    <div>
                      {sortedListLinkData.length > 0 ? (
                        sortedListLinkData.map((linkItem, linkIndex) => (
                          <div key={linkIndex} className="mb-4 p-4 border-b border-gray-300">
                            <p><strong>Link/Site Name: </strong> {linkItem.linkName}</p>
                            <p><strong>Page/Channel Name: </strong> {linkItem.linkPageName}</p>
                            <p><strong>URL/Link Address: </strong> 
                              <span className="link-style" onClick={() => accessSite(linkItem.linkAddress)}>
                                {linkItem.linkAddress}
                              </span>
                            </p>
                            <p><strong>Details: </strong> {linkItem.linkDetails}</p>
                          </div>
                        ))
                      ) : (
                        <div className="mt-20 mb-20 flex justify-center text-blue-600 text-lg">
                          <p className="text-orange-500">There are no Link/Page URLs for this Page!!</p>
                        </div>
                      )}
                      {/* <div className="mt-4 text-center">
                        <button
                          className="bg-purple-700 text-white py-2 px-4 rounded"
                          style={{ maxWidth: "150px" }}
                          onClick={handleListLinkCloseButtonClick}
                        >
                          Close
                        </button>
                      </div> */}
                    </div>
                  )}
                </div>
              </div>
              </>
            )}

          </>
        )}
      </div>
  );
};

export default ReadTVBook;
